import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import LandlineSetup1 from './LandlineSetup1'
import LandlineSetup2 from './LandlineSetup2'
import LandlineSetup3 from './LandlineSetup3'
import LandlineSetup4 from './LandlineSetup4'
import { getEthernetStep5, getLandLineStep5 } from './SetupStep5'
import USBEthernetAdapterSetup1 from './USBEthernetAdapterSetup1'
import USBEthernetAdapterSetup2 from './USBEthernetAdapterSetup2'
import USBEthernetAdapterSetup3 from './USBEthernetAdapterSetup3'
import USBEthernetAdapterSetup4 from './USBEthernetAdapterSetup4'
import ChooseConnectionOption from './ChooseConnectionOption'
import BestConnectionPage from './BestConnectionPage'
import WhereToPlaceMonitorPage from './WhereToPlaceMonitorPage'
import WhatsInMonitorBoxPage from './WhatsInMonitorBoxPage'
import USBCellularAdapterSetup1 from './USBCellularAdapterSetup1'
import USBCellularAdapterSetup5 from './USBCellularAdapterSetup5'
import USBCellularAdapterSetup2 from './USBCellularAdapterSetup2'
import USBCellularAdapterSetup3 from './USBCellularAdapterSetup3'
import USBCellularAdapterSetup4 from './USBCellularAdapterSetup4'
import {
  backOption, backWebOption, closeByPageNum, closeWebView,
} from '../../navigators/NavigatorOptions'

const Stack = createStackNavigator()

export const generateSetupStepScreens = (closeFunction, finishClosesWebView) => (
  <>
    <Stack.Screen name="LandlineSetup1Page" component={LandlineSetup1} options={closeFunction('LandlineSetup1Page', { numberOfScreens: 1 })} />
    <Stack.Screen name="LandlineSetup2Page" component={LandlineSetup2} options={closeFunction('LandlineSetup2Page', { numberOfScreens: 2 })} />
    <Stack.Screen name="LandlineSetup3Page" component={LandlineSetup3} options={closeFunction('LandlineSetup3Page', { numberOfScreens: 3 })} />
    <Stack.Screen name="LandlineSetup4Page" component={LandlineSetup4} options={closeFunction('LandlineSetup4Page', { numberOfScreens: 4 })} />
    <Stack.Screen name="LandlineSetup5Page" component={getLandLineStep5(finishClosesWebView)} options={closeFunction('LandlineSetup5Page', { numberOfScreens: 5 })} />
    <Stack.Screen name="USBEthernetStep1Page" component={USBEthernetAdapterSetup1} options={closeFunction('USBEthernetAdapterSetup1', { numberOfScreens: 1 })} />
    <Stack.Screen name="USBEthernetStep2Page" component={USBEthernetAdapterSetup2} options={closeFunction('USBEthernetAdapterSetup2', { numberOfScreens: 2 })} />
    <Stack.Screen name="USBEthernetStep3Page" component={USBEthernetAdapterSetup3} options={closeFunction('USBEthernetAdapterSetup3', { numberOfScreens: 3 })} />
    <Stack.Screen name="USBEthernetStep4Page" component={USBEthernetAdapterSetup4} options={closeFunction('USBEthernetAdapterSetup4', { numberOfScreens: 4 })} />
    <Stack.Screen name="USBEthernetStep5Page" component={getEthernetStep5(finishClosesWebView)} options={closeFunction('USBEthernetAdapterSetup5', { numberOfScreens: 5 })} />
    <Stack.Screen name="USBCellularStep1Page" component={USBCellularAdapterSetup1} options={closeFunction('USBCellularAdapterSetup1', { numberOfScreens: 1 })} />
    <Stack.Screen name="USBCellularStep2Page" component={USBCellularAdapterSetup2} options={closeFunction('USBCellularAdapterSetup2', { numberOfScreens: 2 })} />
    <Stack.Screen name="USBCellularStep3Page" component={USBCellularAdapterSetup3} options={closeFunction('USBCellularAdapterSetup3', { numberOfScreens: 3 })} />
    <Stack.Screen name="USBCellularStep4Page" component={USBCellularAdapterSetup4} options={closeFunction('USBCellularAdapterSetup4', { numberOfScreens: 4 })} />
    <Stack.Screen
      name="USBCellularStep5Page"
      component={USBCellularAdapterSetup5(finishClosesWebView)}
      options={closeFunction('USBCellularAdapterSetup5', { numberOfScreens: 5 })}
    />
  </>
)

export function CommSetupNoMainStack() {
    return (
      <Stack.Navigator initialRouteName="ChooseConnOpPage" screenOptions={{ gestureEnabled: false }}>
        {generateSetupStepScreens(closeWebView, true)}
      </Stack.Navigator>
    )
}

function allCommSetupScreens(standAloneStack, postMessageOnBack) {
  return (
    <Stack.Navigator initialRouteName="ChooseConnOpPage" screenOptions={{ gestureEnabled: false }}>
      {generateSetupStepScreens(closeByPageNum)}
      <Stack.Screen name="BestConnectionPage" component={BestConnectionPage} options={backOption('BestConnectionContainer')} />
      <Stack.Screen
        name="ChooseConnOpPage"
        component={ChooseConnectionOption}
        options={backWebOption('ChooseConnOpPage', !standAloneStack, postMessageOnBack, 'common:communicatorSetupTitle')}
      />
      <Stack.Screen name="WhereToPlaceMonitorPage" component={WhereToPlaceMonitorPage} options={backOption('WhereToPlaceMonitorPage')} />
      <Stack.Screen name="WhatsInMonitorBoxPage" component={WhatsInMonitorBoxPage} options={backOption('WhatsInMonitorBoxPage')} />
    </Stack.Navigator>
  )
}

export default function Screen() {
  return allCommSetupScreens(true, 'backToGlobal')
}

export function CommSetupScreens() {
  return allCommSetupScreens(false, 'pop')
}
